module.exports = __webpack_public_path__ + "img/wedo_pict05.7573bc61.png";